import classes from './Card.module.scss'
import { CardImage } from './CardImage'
import { CardText } from './CardText'
import { CardTextImage } from './CardTextImage'
import { CardTextAudio } from './CardTextAudio'
import { CardAudio } from './CardAudio'
import { useTranslate } from "@educaplay/core/hooks";
import clsx from 'clsx'
import PropTypes from 'prop-types'

export function Card(props) {
  const { activeYes = false, activeNo = false, text, imgSrc, audioSrc, className, freezed } = props
  const t = useTranslate();
  return (
    <div className={clsx(classes.card, className)}>
      {!text && imgSrc && !audioSrc && <CardImage imageSrc={imgSrc} />}
      {text && imgSrc && !audioSrc && <CardTextImage imageSrc={imgSrc} text={text} />}
      {text && !imgSrc && !audioSrc && <CardText text={text} />}
      {text && !imgSrc && audioSrc && <CardTextAudio text={text} audioSrc={audioSrc} autoplay={!freezed}/>}
      {!text && !imgSrc && audioSrc && <CardAudio audioSrc={audioSrc} autoplay={!freezed}/>}

      <div className={clsx(classes.label, classes.labelNo, { [classes.show]: activeNo })}>
        {t("specific.no")}
      </div>

      <div className={clsx(classes.label, classes.labelYes, { [classes.show]: activeYes })}>
        {t("specific.yes")}
      </div>
    </div>
  )
}

Card.propTypes = {
  activeYes: PropTypes.bool,
  activeNo: PropTypes.bool,
  text: PropTypes.string,
  imgSrc: PropTypes.string,
  audioSrc: PropTypes.string,
  className: PropTypes.string,
  freezed: PropTypes.bool
}